export const arrowRight = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.37733 15.387L8.24633 14.243L13.4723 9.017H0.446328V7.223H13.4723L8.24633 1.997L9.37733 0.853L16.6443 8.12L9.37733 15.387Z"
      fill="white"
      fillOpacity="0.87"
    />
  </svg>
);
